import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";

const BALANCE_QUERY_ROOTS = [QueryKeys.Balance, QueryKeys.BalanceSummary] as const;

/** Balance list, summary, and widget revenue after balance mutations. */
export async function invalidateBalanceQueries(
  queryClient: QueryClient,
): Promise<void> {
  await Promise.all([
    ...BALANCE_QUERY_ROOTS.map((key) =>
      queryClient.invalidateQueries({ queryKey: [key], refetchType: "all" }),
    ),
    queryClient.invalidateQueries({
      queryKey: [QueryKeys.WidgetData],
      refetchType: "all",
    }),
  ]);
}
